import Alert from '../../Alert';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { uniqBy } from 'lodash';
import { connect } from 'react-redux';
import {
  getDepartmentabbreviation,
  hasLinkkipalveluLinkValue,
} from '../../../utils/TimelineUtils';

/**
 * Return appointments which have one of the the given comments
 *
 * @param existingAppointments existing appointments
 * @param commentOptions array of comments to be checked
 * @returns {*} array of appointments with given comments
 */
export const reservedAppointmentsWithComment = (
  existingAppointments,
  commentOptions
) =>
  uniqBy(
    existingAppointments.filter((a) => commentOptions.indexOf(a.comment) >= 0),
    'comment'
  );

/*
 * Show alerts for Maternity clinic. If user already has reserved a time for a
 * certain clinic (marked by a Y, S, R, or R24 comment), an alert is shown here for each.
 */
function MaternityClinicAlerts(props) {
  const { existingAppointments, linkkipalvelu } = props;

  const getLinkValue = (departmentAbbr) => {
    return (
      linkkipalvelu.Toimipistetiedot &&
      linkkipalvelu.Toimipistetiedot[departmentAbbr]
    );
  };

  let reservedAppointments = reservedAppointmentsWithComment(
    existingAppointments,
    ['Y', 'S', 'R', 'R24']
  );

  if (reservedAppointments.length >= 0) {
    return reservedAppointments.map((appointment) => (
      <Alert key={appointment.comment}>
        {hasLinkkipalveluLinkValue(
          getLinkValue(getDepartmentabbreviation(appointment.location))
        ) ? (
          <>
            <FormattedMessage
              id={`appointment.reservation.maternityultra.reserved.alert.${appointment.comment}`}
              values={{
                Ylink: (chunks) => (
                  <a
                    href={getLinkValue(
                      getDepartmentabbreviation(appointment.location)
                    )}
                    target="_blank"
                  >
                    {chunks}
                  </a>
                ),
                Slink: (chunks) => (
                  <a
                    href={getLinkValue(
                      getDepartmentabbreviation(appointment.location)
                    )}
                    target="_blank"
                  >
                    {chunks}
                  </a>
                ),
                Rlink: (chunks) => (
                  <a
                    href={getLinkValue(
                      getDepartmentabbreviation(appointment.location)
                    )}
                    target="_blank"
                  >
                    {chunks}
                  </a>
                ),
                R24link: (chunks) => (
                  <a
                    href={getLinkValue(
                      getDepartmentabbreviation(appointment.location)
                    )}
                    target="_blank"
                  >
                    {chunks}
                  </a>
                ),
              }}
            />
          </>
        ) : (
          <>
            <FormattedMessage
              id={`appointment.reservation.maternityultra.reserved.alert.${appointment.comment}.no.link`}
            />
          </>
        )}
      </Alert>
    ));
  }

  return null;
}

const mapStateToProps = (state) => {
  return {
    linkkipalvelu: state.linkkipalvelu,
  };
};

export default connect(mapStateToProps)(MaternityClinicAlerts);
